// extracted by mini-css-extract-plugin
export default {"searchBarContainer":"SearchBarOnChange_searchBarContainer__NGICO","searchIcon":"SearchBarOnChange_searchIcon__p8bFv","searchInput":"SearchBarOnChange_searchInput__brIX+"};